<template>
    <stat-layout-card>
        <template slot="title">
             <h2 class="m-0">{{ data.title }}</h2>
        </template>
        <template slot="content">
            <div class="data-block-number aright" v-if="mainSlot">
                <h3 class="data-value aright" v-for="(mainSlot, mainSlotIndex) in mainSlot.slots" :key="mainSlotIndex">
                    {{ mainSlot.type == 'amount' ? $options.filters.numberformat(mainSlot.value) : mainSlot.value }} {{mainSlot.unit ? mainSlot.unit : '' }}
                </h3>
            </div>
            <h4 class="grey ml-2">{{ $l10n.__("Total") }}</h4>
            <div v-for="(stat, statIndex) in data.slots" :key="statIndex" class="stats-block stats-inline" v-if="stat.name != 'total'">
                <a :href="stat.link" target="_blank" class="primary-50-hover cpointer gray-100">
                    <h3 class="stats-title">{{ stat.label }}</h3>
                    <div v-for="(value, valueIndex) in stat.slots" :key="valueIndex" class="data-block-number inline-block">
                        <h3 class="data-value m-0">{{ value.type == 'amount' ? $options.filters.numberformat(value.value) : value.value }} {{value.unit ? value.unit : '' }}</h3>
                        <!-- <p class="data-label">{{ value.label }}</p> -->
                    </div>
                </a>
            </div>
        </template>
    </stat-layout-card>
</template>

<script>
    import StatLayoutCard from './StatLayoutCard.vue'
    export default {
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        data(){
            return {
            }
        },
        computed: {
            mainSlot(){
                let mainSlot = this.data.slots.find(slot => slot.name == 'total')
                if(mainSlot){
                    return mainSlot
                }
                return false
            }
        },
        components: {
            StatLayoutCard
        }
    }
</script>

<style scoped>

</style>